module.exports = __webpack_public_path__ + "img/arrow-down-white-icon.6918a9df.svg";